import { render, staticRenderFns } from "./ManagingAppealProcessPg.vue?vue&type=template&id=46420afa&scoped=true"
import script from "./ManagingAppealProcessPg.vue?vue&type=script&lang=ts"
export * from "./ManagingAppealProcessPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46420afa",
  null
  
)

export default component.exports